import{mergeMap as r}from"./mergeMap.js";import{identity as t}from"../util/identity.js";function i(i){return void 0===i&&(i=Number.POSITIVE_INFINITY),r(t,i)}export{i as mergeAll};
